import { render, staticRenderFns } from "./prive.vue?vue&type=template&id=18c12c46&scoped=true&"
import script from "./prive.vue?vue&type=script&lang=js&"
export * from "./prive.vue?vue&type=script&lang=js&"
import style0 from "./prive.vue?vue&type=style&index=0&id=18c12c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c12c46",
  null
  
)

export default component.exports